import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { TextField, Button, Typography, Box } from "@mui/material";
import handleService from "../../services/apiService.ts";
import { MethodsEnum } from "../../enums/Methods.ts";
import { useFeedback } from "../../contexts/FeedbackContext.tsx";

const schema = yup.object().shape({
  nomeEmpresa: yup.string().required("Nome da empresa é obrigatório"),
  cnpj: yup.string().min(14, "CNPJ inválido").required("CNPJ é obrigatório"),
  emailEmpresa: yup
    .string()
    .email("E-mail inválido")
    .required("E-mail da empresa é obrigatório"),
  telefone: yup.string().required("Telefone é obrigatório"),
  email: yup.string().email("E-mail inválido").required("E-mail é obrigatório"),
  senha: yup
    .string()
    .min(6, "A senha deve ter pelo menos 6 caracteres")
    .required("Senha obrigatória"),
});

const SetupPage = () => {
  const navigate = useNavigate();
  const { showFeedback } = useFeedback();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    try {
      const response = await handleService({
        method: MethodsEnum.POST,
        endpoint: "/setup",
        data,
      });

      showFeedback(response.message, "success");
      navigate("menu");
    } catch (error) {
      showFeedback(error.message, "error");
    }
  };

  return (
    <Box sx={{ textAlign: "center", padding: 4 }}>
      <Typography variant="h4" gutterBottom>
        Cadastro Inicial
      </Typography>

      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{ display: "grid", gap: "20px" }}
      >
        <TextField
          label="Nome da Empresa"
          variant="outlined"
          fullWidth
          {...register("nomeEmpresa")}
          error={!!errors.nomeEmpresa}
          helperText={errors.nomeEmpresa?.message}
        />
        <TextField
          label="CNPJ"
          variant="outlined"
          fullWidth
          {...register("cnpj")}
          error={!!errors.cnpj}
          helperText={errors.cnpj?.message}
        />
        <TextField
          label="Email da Empresa"
          variant="outlined"
          fullWidth
          {...register("emailEmpresa")}
          error={!!errors.emailEmpresa}
          helperText={errors.emailEmpresa?.message}
        />
        <TextField
          label="Telefone"
          variant="outlined"
          fullWidth
          {...register("telefone")}
          error={!!errors.telefone}
          helperText={errors.telefone?.message}
        />
        <TextField
          label="Email do Usuário"
          variant="outlined"
          fullWidth
          {...register("email")}
          error={!!errors.email}
          helperText={errors.email?.message}
        />
        <TextField
          label="Senha"
          variant="outlined"
          fullWidth
          type="password"
          {...register("senha")}
          error={!!errors.senha}
          helperText={errors.senha?.message}
        />

        <Button
          variant="contained"
          color="primary"
          type="submit"
          sx={{ padding: "10px", fontSize: "16px", marginTop: "20px" }}
        >
          Cadastrar
        </Button>
      </form>
    </Box>
  );
};

export default SetupPage;
